import { render, staticRenderFns } from "./CustomersView.html?vue&type=template&id=f9643f90&scoped=true&"
import script from "./CustomersView.js?vue&type=script&lang=js&"
export * from "./CustomersView.js?vue&type=script&lang=js&"
import style0 from "./CustomersView.scss?vue&type=style&index=0&id=f9643f90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9643f90",
  null
  
)

component.options.__file = "CustomersView.vue"
export default component.exports